import { render, staticRenderFns } from "./ShieldingPage.vue?vue&type=template&id=aac3af90&scoped=true"
import script from "./ShieldingPage.vue?vue&type=script&lang=js"
export * from "./ShieldingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aac3af90",
  null
  
)

export default component.exports